import axios from 'axios';
import { db } from '../components/Dexie'; // Importa Dexie
import { log } from './loggingService';

const API_URL = 'https://deadapi.techysumo.it/';
const API_AUT = process.env.REACT_APP_API_KEY;
const API_HEADER = {
  Authorization: API_AUT // Rimosso 'Bearer ' come visto in Settings.js
}

// Ottenere tutte le traduzioni Telegram
export const getTelegramTranslations = async (lastUpdate = null) => {
  const payload = {};
  if (lastUpdate) {
    payload.lastupdate = lastUpdate;
  }

  const response = await axios.post(`${API_URL}telegram/listString`, payload, { headers: API_HEADER });
  const apiTranslations = response.data;

  console.log(response.data, payload, API_URL);

  if (!apiTranslations || !apiTranslations.result) {
    return false;
  }

  // apiTranslations.details dovrebbe contenere l'array di traduzioni
  if (apiTranslations.details && Array.isArray(apiTranslations.details)) {
    await db.strings.bulkPut(apiTranslations.details);
  }

  const now = new Date();
  await db.genericTable.put({
    table: 'settings',
    field: 'lastupdatestringtelegram',
    value: now.toISOString(), // Salviamo in formato ISO o timestamp come richiesto
    date: now.getTime()
  });

  return apiTranslations.details;
};

// Ottenere tutte le traduzioni (legacy/standard)
export const getTranslations = async () => {

  let data = {
    auth: API_AUT
  };
  const response = await axios.post(`${API_URL}getStrings`, data, { headers: API_HEADER });
  const apiTranslations = response.data;

  if (!apiTranslations || !apiTranslations.result)
    return false;

  await db.strings.bulkPut(apiTranslations.details);
  const lastTimeUpdate = new Date();
  db.genericTable
    .put({ table: 'genericData', field: 'lastUpdateDateTime', value: lastTimeUpdate.getTime() })
    .then(() => log("datetime aggiornato", "INFO"))
    .catch(() => log("datetime non aggiornato", "ERROR"));
  return apiTranslations.details;

};

// Aggiornare una traduzione Telegram
export const updateTelegramTranslation = async (stringId, originalLanguage, values) => {

  console.log(values, stringId, originalLanguage);

  const payload = {
    values: values, // Array di {field, value}
    filter: [
      { field: 'string', value: stringId },
      { field: 'language', value: originalLanguage }
    ]
  };

  const response = await axios.post(`${API_URL}telegram/updateString`, payload, { headers: API_HEADER });
  return response.data;
};

// Cancellare una traduzione
export const deleteTranslation = async (id) => {

  const data = {};
  data.table = 'exkart_strings';
  data.filter = [
    { field: "string", value: id.string },
    { field: "language", value: id.language }
  ];
  const result = await axios.post(`${API_URL}deleteDatabase`, data, { headers: API_HEADER });

  return result;

};

// Modificare una traduzione
export const modifyTranslation = async (original, update) => {

  let data = {
    original: original,
    update: update
  };

  return axios.post(`${API_URL}modifyTranslation`, data, { headers: API_HEADER });

};

// Aggiungere una traduzione
export const addTranslation = async (newDescription) => {
  return axios.post(`${API_URL}addTranslation`, newDescription, { headers: API_HEADER });
};

export const newStringTranslation = async () => {
  const data = {};
  data.table = 'exkart_strings';
  const response = await axios.post(API_URL + "getRandomNumber", data, { headers: API_HEADER });
  return response.data;
};

// Ottenere un nuovo ID per una stringa telegram
export const getNewIdString = async () => {
  const response = await axios.post(`${API_URL}telegram/getNewIdString`, {}, { headers: API_HEADER });
  return response.data;
};

// Inserire una nuova traduzione telegram
export const insertTelegramTranslation = async (data) => {
  const response = await axios.post(`${API_URL}telegram/insertString`, data, { headers: API_HEADER });
  return response.data;
};

// Cancellare una traduzione telegram
export const deleteTelegramTranslation = async (stringId, language) => {
  const payload = {
    string: stringId ,
    language: language
  };
  const response = await axios.post(`${API_URL}telegram/deleteString`, payload, { headers: API_HEADER });
  return response.data;
};

export const getDescriptionTranslate = async (toLanguage, description, fromLanguage = false) => {

  let data = {};
  data.toLanguage = toLanguage;
  data.description = description;
  if (fromLanguage)
    data.fromLanguage = fromLanguage;

  const response = await axios.post(API_URL + "getTranslate", data, { headers: API_HEADER });
  return response.data;

};